import { service } from "@/api/service ";
import { toastError, toast } from "@/components/custom/Toast";
//import store from "../..";

const state = {
  leaveTypes: [],
  leaveType: {},
  roles: [],
  pagination: {},
  addStatus: false,
  editStatus: false,
  deleteStatus: false,
};
const getters = {
  leaveTypesListGet: (state) => state.leaveTypes,
  // rolesListGet: (state) => state.roles,
  leaveTypeGet: (state) => state.leaveType,
};
const actions = {
  async getLeaveTypes({ commit }) {
    const result = await service.getFun(`vacation-types`);
    if (result) {
      commit("leaveTypesListSet", result.data);
    }
  },
  // getLeaveTypes({ commit }, payload) {
  //   let page = payload.isModal ? 0 : store.state.page.page;
  //   service.getFun(`vacation_types?page=${page}`).then(
  //     (obj) => {
  //       var result = obj.data;
  //       const pageresult = {
  //         currentPage: obj.data.current_page,
  //         lastPage: obj.data.last_page,
  //         itemsPerPage: obj.data.per_page,
  //         total: obj.data.total,
  //       };
  //       commit("leaveTypesListSet", result);
  //       commit("setPagination", pageresult);
  //     },
  //     (error) => {
  //       console.log("leaveTypes..." + error);
  //       toastError(error);
  //     }
  //   );
  // },

  addLeaveType({ commit }, payload) {
    service
      .postFun(service.deleteNullValues(payload), `vacation-types`, null, {
        action: "getLeaveTypes",
      })
      .then(
        (result) => {
          commit("addLeaveTypeStatus", result.success);
          toast(result.message);
        },
        (error) => {
          console.log("courses..." + error);
          toastError(error);
        }
      );
  },
  editLeaveType({ commit }, payload) {
    service
      .postFun(
        service.deleteNullValues(payload),
        `vacation-types/${payload.id}`,
        null,
        {
          action: "getLeaveTypes",
        }
      )
      .then(
        (result) => {
          if (result) {
            commit("editLeaveTypeStatus", result.success);
            toast(result.message);
          } else {
            commit("editLeaveTypeStatus", false);
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
  async deleteLeaveType({ commit }, payload) {
    console.log(payload, "payload");
    const result = await service.deleteFun(
      `vacation-types/${payload?.payload}`,
      {
        action: "getLeaveTypes",
      }
    );
    if (result) {
      commit("deleteLeaveTypeStatus", result?.success);
      toast(result?.message);
    }
  },
};
const mutations = {
  leaveTypesListSet(state, leaveTypes) {
    state.leaveTypes = leaveTypes;
  },
  rolesListSet(state, roles) {
    state.roles = roles;
  },
  getLeaveTypeById(state, leaveType) {
    state.leaveType = leaveType;
  },
  addLeaveTypeStatus(state, Status) {
    state.addStatus = Status;
  },
  editLeaveTypeStatus(state, Status) {
    state.editStatus = Status;
  },
  deleteLeaveTypeStatus(state, Status) {
    state.deleteStatus = Status;
  },
  setPagination(state, pageResult) {
    state.pagination = pageResult;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
